export const getColor = (availableColor = 'primary') => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const color = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(`--${availableColor}`);

  return color.toUpperCase().trim();
};
